import React from 'react';
import styled from 'styled-components';

import { ListingListItem } from 'components';

import type { GetSimpleListingsByIdsDTO } from '@/app-package';

import { ListingContainer } from '../common';

interface TeamListingDetailsProps {
  teamListings: GetSimpleListingsByIdsDTO['listings'];
  goToListing: (listingId: string) => void;
}

const TeamListingDetails: React.FC<TeamListingDetailsProps> = ({
  teamListings,
  goToListing,
}) => (
    <StyledContent>
      {teamListings.map(listing => (
        <ListingContainer
          key={listing.id}
          onClick={() => goToListing(listing.id)}
        >
          {/* @ts-expect-error Need to update SimpleListing in domain to include city and province */}
          <ListingListItem listing={listing} />
        </ListingContainer>
      ))}
    </StyledContent>
  );

export default TeamListingDetails;

const StyledContent = styled.div`
  max-height: 20vh;
  overflow-y: auto;
`;
